import React from "react";
import SunEditor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { uploadJPG } from "./fileUploadHelper";
import { addImageAndGetUrl } from "./apiHelpers";
import config from "./config";

type HTMLEditorProps = {
  content: string;
  setContent: React.Dispatch<string>;
};

const handleImageUpload = (
  toUpload: File,
  _: object,
  uploadHandler: Function
) => {
  const errorHandling = () => {
    uploadHandler(null);
  };

  const { type, size, name } = toUpload;
  if (type !== "image/jpeg") {
    alert("Seul le format JPG est accepté");
    errorHandling();
  } else if (size > config.imageSizeLimitInBytes) {
    alert(config.imageToHeavyMessage);
    errorHandling();
  } else {
    const imageCallback = async (file: string | ArrayBuffer | null) => {
      try {
        const url = await addImageAndGetUrl(file as string, name.split(".")[0]);
        const result = [{ url, name, size }];
        setTimeout(() => uploadHandler({ result }), config.imageTemporisation);
      } catch (e: any) {
        alert(JSON.stringify(e));
        errorHandling();
      }
    };

    uploadJPG(toUpload, imageCallback, errorHandling);
  }
};

const HTMLEditor: React.FC<HTMLEditorProps> = ({ content, setContent }) => (
  <SunEditor
    lang="fr"
    height="500px"
    defaultValue={content}
    onChange={(content) => {
      setContent(content);
    }}
    setOptions={{
      buttonList: [
        ...buttonList.basic,
        ["formatBlock"],
        ...buttonList.formatting,
      ],
    }}
    onImageUploadBefore={(files, imageInfo, uploadHandler) => {
      if (files) {
        handleImageUpload(files[0], imageInfo, uploadHandler);
      }
    }}
  />
);

export default HTMLEditor;
